import React from "react";
import PropTypes from "prop-types";
import StyledText from "ae-base/Base/StyledText";
import InputContainer from "./Layout/InputContainer";
import InputLabel from "./Layout/InputLabel";

export default function UnsupportedFeature(props, context){
	const schema = props.schema;
	const inputType = schema.inputType;
	const format = schema.format;

	const localize = context.localize;

	return (
		<InputContainer inline={props.inline} stretch={schema.stretch}>
			<InputLabel schema={schema} />
			<StyledText>
				{localize("forms.unsupported", {
					type: inputType || format
				})}
			</StyledText>
		</InputContainer>
	);
}

UnsupportedFeature.contextTypes = {
	localize: PropTypes.func
};
